import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { ContentBlock } from 'components/contentBlock/ContentBlock'
import { RadioButton } from 'components/radioButtonGroup/RadioButton'

import styles from './RadioButtonGroup.module.scss'

const binaryRadioGroupOptions = [
  { id: true, title: 'Yes' },
  { id: false, title: 'No' },
]

export const RadioButtonGroup = ({
  className,
  buttonClassName,
  isRequired,
  title,
  options = binaryRadioGroupOptions,
  value,
  name,
  onChange,
  error = null,
  size = 'compact',
  listType = 'inline',
  lastrow,
  dataTestId,
  isDisabled,
}) => (
  <ContentBlock
    title={title}
    isRequired={isRequired}
    className={classNames(
      styles.container,
      {
        [styles.columnsContainer]: listType === 'columns',
      },
      className,
    )}
    size={size}
    lastrow={lastrow}
    data-test-id={dataTestId}>
    <div
      className={classNames(styles.radioGroup, {
        [styles.disabled]: isDisabled,
        [styles.list]: listType === 'block',
        [styles.columns]: listType === 'columns',
      })}>
      {options.map((option, index) => (
        <RadioButton
          key={index}
          index={index}
          option={option}
          value={value}
          name={name}
          onChange={onChange}
          listType={listType}
          className={buttonClassName}
          isDisabled={isDisabled}
        />
      ))}
    </div>

    {error && (
      <div className={styles.error} data-test-id="radio-button-error">
        {error}
      </div>
    )}
  </ContentBlock>
)

RadioButtonGroup.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  buttonClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isRequired: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  size: PropTypes.string,
  title: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isBinary: PropTypes.bool,
  error: PropTypes.node,
  lastrow: PropTypes.bool,
  isDisabled: PropTypes.bool,
  listType: PropTypes.oneOf(['block', 'inline', 'columns']),
}
